import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import { getOption, configuration } from '@/setting';

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../src/theme/theme.scss";
Vue.use(ElementUI);

// global_css
import './style.scss';

// echarts
import 'echarts-gl';
import VueEcharts from "vue-echarts-ts";
Vue.use(VueEcharts);

// 转换显示的true和false
Vue.filter('truefalse', function (text: any) {
  if (text === null) return '';
  if (text === true) {
    return "是";
  } else if (text === false) {
    return "否";
  }
})
Vue.filter('dataFormat', (input: string, pattern = '') => {
  const dt = new Date(input);
  // 获取年月日
  const y = dt.getFullYear();
  const M = (dt.getMonth() + 1).toString().padStart(2, '0');
  const d = dt.getDate().toString().padStart(2, '0');
  const hh = dt.getHours().toString().padStart(2, '0');
  const mm = dt.getMinutes().toString().padStart(2, '0');
  const ss = dt.getSeconds().toString().padStart(2, '0');
  // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
  // 否则，就返回  年-月-日 时：分：秒
  if (pattern === 'yyyy/MM/dd') {
    return `${y}/${M}/${d}`;
  } else if (pattern === 'HH:mm:ss') {
    return `${hh}:${mm}:${ss}`;
  } else if (pattern === '年月日') {
    return `${y}年${M}月${d}日`;
  } else {
    return `${y}-${M}-${d} ${hh}:${mm}:${ss}`;
  }
});

new Vue({
  router,
  store,
  render: (h) => {
    store.commit('updateConfiguration', configuration,)
    getOption().then((data: any) => {
      window.OPTION = data;
    });
    return h(App);
  },
}).$mount('#app')

